import React, { forwardRef } from 'react';

import { Box, Divider, Flex } from '@chakra-ui/react';
import { SupportedBySectionHeader } from 'components/RabbitOKRSidePanel/Components/SectionHeaders';
import { useGetOKRChildren } from 'components/RabbitOKRSidePanel/datahooks/useGetOKRChildren';
import { useSelector } from 'react-redux';
import { kRDrawerSelector } from 'selectors/kRDrawer';

import { SupportedByOKRs } from './SupportedByOKRs';

const SupportedBy = ({ isOKRPanelDisabled }) => {
  const { uuid, type: parentType } = useSelector(kRDrawerSelector);

  const { data, isLoading, isError, error } = useGetOKRChildren({
    id: uuid,
    enabled: Boolean(uuid),
  });

  const isEmpty = data?.length === 0;

  return (
    <Flex flexDirection="column" alignItems="stretch" gap="12px" flexWrap="nowrap" w="100%">
      <SupportedBySectionHeader isEmpty={isEmpty || isOKRPanelDisabled} />
      <Divider sx={{ borderColor: '#CFD7DF' }} />
      <SupportedByOKRs
        data={data}
        isLoading={isLoading}
        isError={isError}
        error={error}
        isOKRPanelDisabled={isOKRPanelDisabled}
      />
    </Flex>
  );
};

export default SupportedBy;

export const RefableSupportedBy = forwardRef((props, ref) => (
  <Box ref={ref} w="100%">
    <SupportedBy {...props} />
  </Box>
));
